/* eslint-disable no-unused-vars */
import throttle from 'lodash/throttle';

/**
 * Check for scroll position and add body classes
 * to assist with styling
 */
const init = () => {
	const filterArea = document.querySelector('.search-filter-area');
	const sponsoredBy = document.querySelector('.search-sponsored-by');

	// bail if no filter area
	if (!filterArea) {
		return;
	}
	// Add a body class if we have a Sponsored By area
	if (sponsoredBy) {
		document.body.classList.add('has-sponsored-bar');
	}

	/**
	 * Add the classes
	 */
	function checkScrollPosition() {
		if (matchMedia('only screen and ( min-width: 960px )').matches) {
			if (window.pageYOffset < 243) {
				document.body.classList.remove('search-filters-sticky');
			} else {
				document.body.classList.add('search-filters-sticky');
			}
		}
	}

	// run checkScrollPosition() on load, scroll and resize
	checkScrollPosition();
	// window.addEventListener( 'scroll', checkScrollPosition );
	window.addEventListener('scroll', throttle(checkScrollPosition, 100));
};

init();
window.addEventListener('resize', init);
